import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityListController.php
* @route '/api/city'
*/
const GetWikiCityListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiCityListController.url(options),
    method: 'get',
})

GetWikiCityListController.definition = {
    methods: ["get","head"],
    url: '/api/city',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityListController.php
* @route '/api/city'
*/
GetWikiCityListController.url = (options?: RouteQueryOptions) => {
    return GetWikiCityListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityListController.php
* @route '/api/city'
*/
GetWikiCityListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiCityListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityListController.php
* @route '/api/city'
*/
GetWikiCityListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiCityListController.url(options),
    method: 'head',
})

export default GetWikiCityListController